import styled from "styled-components";
import React from "react";
import SliderRound from "../common/slider-round";

const Container = styled.div``;

//text-transform: capitalize;

const TagOptions = styled.div`
  padding: 0;
  label,
  input {
    cursor: pointer;
  }
  .role-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0 0 0;
    color: #fff7f0;
  }
  .role-divider {
    border: none;
    border-bottom: 2px solid #3a1818;
    margin: 0 0 0 0;
  }
`;

const TagOption = ({ name, label, selected, onChange }) => {
  const onChangeHandler = (event) => {
    onChange &&
      onChange({
        name,
        selected: event.target.checked,
      });
  };

  return (
    <div className="role-row border-b border-b-[#252632] pb-3">
      <span className="font-body-primary text-base font-[300]">{label || name}</span>
      <SliderRound
        checked={selected}
        onChange={onChangeHandler}
        name={name}
        id={name}
      />
    </div>
  );
};

const isInTagsArray = (tag, tagsArray) => {
  tag ||= "";
  return (tagsArray || []).filter((item) => item === tag).length > 0;
};

export const TagEditor = ({ options, value, onChange, delim, allowEmpty }) => {
  delim ||= ",";
  let tagsArray = (value || "").split(delim);

  const onChangeHandler = ({ name, selected }) => {
    const index = tagsArray.findIndex((tag) => tag === name);

    if (selected && index < 0) {
      tagsArray.push(name);
    } else if (!selected && index >= 0) {
      tagsArray.splice(index, 1);
    }

    if (!allowEmpty && tagsArray.length === 0) {
      tagsArray = value.split(delim);
      return;
    }
    onChange && onChange(tagsArray.join(delim), value);
  };

  return (
    <Container>
      <div>
        <label className="font-headings-primary text-[18px] mt-2">User permissions</label>
      </div>
      <TagOptions>
        {options.map((option, idx) => (
          <React.Fragment key={option.name}>
            <TagOption
              name={option.name}
              label={option.label}
              onChange={onChangeHandler}
              selected={isInTagsArray(option.name, tagsArray)}
            />
            {idx < options.length - 1 && <hr className="role-divider" />}
          </React.Fragment>
        ))}
      </TagOptions>
    </Container>
  );
};
